import {
    DEVICES_BULK_PAIRING_OPEN_MODAL,
    DEVICES_BULK_PAIRING_CLOSE_MODAL,
    DEVICES_BULK_PAIRING_REQUEST,
    DEVICES_BULK_PAIRING_RESULT,
    DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST,
    DEVICES_BULK_PAIRING_SEARCH_DEVICES_RESULT,
    DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST,
    DEVICES_BULK_PAIRING_SEARCH_ID_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    devices: null,
    camerasIds: null,
    gpsIds: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case DEVICES_BULK_PAIRING_OPEN_MODAL:
            return { ...state, openModal: true };

        case DEVICES_BULK_PAIRING_CLOSE_MODAL:
            return { ...state, openModal: false };

        case DEVICES_BULK_PAIRING_REQUEST:
            return { ...state, loading: true };

        case DEVICES_BULK_PAIRING_RESULT:
            return { ...state, loading: false, result: action.payload };

        case DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST:
            return { ...state, loading: true };

        case DEVICES_BULK_PAIRING_SEARCH_DEVICES_RESULT:
            return { ...state, loading: false, devices: action.payload };

        case DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST:
            return { ...state, loading: true }

        case DEVICES_BULK_PAIRING_SEARCH_ID_RESULT:
            const { result, type } = action.payload
            return {
                ...state,
                loading: false,
                camerasIds: type === "camera" ? result : null,
                gpsIds: type === "gps" ? result : null
            }

        case CLEAR_REDUX:
            return ["", "DEVICES_BULK_PAIRING"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};